import { Route, Routes, useLocation } from "react-router-dom";
import CommonProvider from "./provider/CommonProvider";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./App.css";
import PageDecryptAES from "./components/Home/PageDecryptAES/PageDecryptAES";
import Home from "../src/components/Home/Home";
// import HomePopup from '../src/components/HomePopup/HomePopup';
import PopupButton from "../src/components/HomePopup/PopupButton";
import Download from "./components/Download/Download";
import AboutUs from "./components/AboutUs/AboutUs";
import NotFound from "./components/NotFound/NotFound";
import Perspective from "./components/Perspective/Perspective";

import DownloadInner from "./components/Download/DownloadInner/DownloadInner";
import FinQ from "./components/FinQ/FinQ";
import OurFundInner from "./components/Home/OurFundInner/OurFundInner";
import BlogDetails from "./components/Perspective/BlogDetails/BlogDetails";
import Calculator from "./components/Calculator/Calculator";
import KfinBranches from "./components/ReachOut/KfinBranches/KfinBranches";
import BranchLocator from "./components/ReachOut/BranchLocator/BranchLocator";
import TabsNavDividend from "./components/Navs/TabsNavDividend/TabsNavDividend";
import PartnersCorner from "./components/PartnersCorner/PartnersCorner";
import CustomerServices from "./components/CustomerServices/CustomerServices";
import PrivacyPolicy from "./components/FooterLinkData/PrivacyPolicy/PrivacyPolicy";
import Disclaimer from "./components/FooterLinkData/Disclaimer/Disclaimer";
import RulesAndRegulations from "./components/FooterLinkData/RulesAndRegulations/RulesAndRegulations";
import ReachOut from "./components/ReachOut/ReachOut";
import TabsPartner from "./components/PartnersCorner/TabsPartner/TabsPartner";
import Product from "./components/Product/Product";
import ProductSheme from "./components/Product/ProductSheme/ProductSheme";
import SearchPopup from "./components/SearchPopup/SearchPopup";
import MediaCenter from "./components/MediaCenter/MediaCenter";
import DownloadNew from "./components/Download/DownloadNew/DownloadNew";
import TransmissionUnits from "./components/TransmissionUnits/TransmissionUnits";
import ODRPortal from "./components/ODRPortal/ODRPortal";
import Sponsor from "./components/AboutUs/Sponsor/Sponsor";
import Auditor from "./components/AboutUs/Auditor/Auditor";
import Custodian from "./components/AboutUs/Custodian/Custodian";
import Registar from "./components/AboutUs/Registar/Registar";
// import SMSCodeForScheme from "./components/Navs/SMSCodeForScheme/SMSCodeForScheme";
import CompanyBoilerplate from "./components/MediaCenter/CompanyBoilerplate/CompanyBoilerplate";
import MeadiaVdieos from "./components/MediaCenter/PressRelease/MeadiaVdieos/MeadiaVdieos";
import PressRelease from "./components/MediaCenter/PressRelease/PressRelease";
import ContactUsForm from "./components/CustomerServices/CustomerServicesSection/ContactUsForm/ContactUsForm";
import UnclaimedDividendHistory from "./components/Navs/UnclaimedDividendHistory/UnclaimedDividendHistory";
import ExecutiveRemuneration from "./components/AboutUs/CorporateProfile/ExecutiveRemuneration";
import CommunicationHub from "./components/CommunicationHub/CommunicationHub";
import TERRatio from "./components/TER/TERRatio";
import SIDdisclosures from "./components/SIDdisclosures/SIDdisclosures";
// import KycPopup from "./components/HomePopup/KycPopup";
import Kyc from "./components/Kyc/Kyc";
import Draft1 from "./components/Draft/Draft1";
import Draft2 from "./components/Draft/Draft2";
import KycForm from "./components/Kyc/KycForm2";
import Camsresponse from "./components/Kyc/Camsresponse";
import PaymentEfficiency from "./components/Navs/PaymentEfficiency/PaymentEfficiency";
import FinQFAQ from "./components/FinQ/FinQSection/FinQFAQ/FinQFAQ";
import DocumentGalleryInner from "./components/FinQ/FinQSection/DocumentGallery/DocumentGalleryInner";
import DocumentGallery from "./components/FinQ/FinQSection/DocumentGallery/DocumentGallery";
import Careers from "./components/Careers/Careers";
import Confirmation from "./components/Header/Confirmation";
import FinQKYC from "./components/FinQ/FinQSection/FinQKYC/FinQKYC";
import FinQKYCOther from "./components/FinQ/FinQSection/FinQKYCOther/FinQKYCOther";
import CyberSecurity from "./components/FooterLinkData/CyberSecurity/CyberSecurity";
import { useEffect } from "react";
import TagManager from "react-gtm-module";
import MainUnclaimedHistory from "./components/Navs/UnclaimedDividendHistory/MainUnclaimedHistory";
import BlogPage from "./components/NewBlogsSection/MainBlogPage/BlogPage";
import InnerBlogPage from "./components/NewBlogsSection/InnerBlogPage/InnerBlogPage";
import AIFHomePage from "./components/AIF/AIFHomePage";
import Calendar2026 from "./components/FinQ/FinQSection/Calendar/Calendar2026";
import SmsCodeForSchemeNew from "./components/Navs/SMSCodeForScheme/SmsCodeForSchemeNew";
import AIFAboutUs from "./components/AIF/AIFAboutUs/AIFAboutUs";
import IAPMicrosite from "./components/IAPMicrosite/IAPMircroSitePage";
import Outlook2026 from "./components/FinQ/FinQSection/Outlook2026/Outlook2026";
// import Co_Pms from "./components/FooterLinkData/CoPms/Co_Pms";
import CoPms from "./components/FooterLinkData/CoPms/Co_Pms";
import SMSCodeForScheme from "./components/Navs/SMSCodeForScheme/SMSCodeForScheme";
import SchemeExpenseRatio from "./components/FooterLinkData/SchemeExpenseRatio/SchemeExpenseRatio";
import Grievance from "./components/Grievance/Grievance";
import RegistrationDetails from "./components/RegistrationDetails";
import LockFreezePage from "./components/LockFreezePage";
import AccessibilityWidget from "./components/AccessibilityWidget";
import ScrollToTopButton from "./components/ScrollToTop/ScrollToTopButton";
// import SIPCalculator from "./components/SIPCalculator/SIPCalculator";
import AIFProductPage from "./components/AIF/AIFProductPage/AIFProductPage";
import AIFContactus from "./components/AIF/AIFContactUs/AIFContactUs";
import NfoPopup from "./components/NfoPopup/NfoPopup";
import SIPCalculator from "./components/SIPCalculator/SIPCalculator";
import DematerialisationProcess from "./components/DematerialisationProcess/DematerialisationProcess";
import AIFInsights from "./components/AIF/AIFInsights/AIFInsights";
import EmapanelledMfd from "./components/FooterLinkData/EmapanelledMfd/EmapanelledMfd";
import LatestPartnerCorner from "./components/PartnersCorner/LatestPartnerCorner/Latestpartnercorner";
import FactSheetDisclosures from "./components/FactSheetDisclosures/FactSheetDisclosures";
import JMWhatsAppAssistant from "./components/JMWhatsappPage/JMWhatsAppAssistant";
import CobrandPartners from "./components/CobrandedPartners/CobrandedPartners";
// import ErrorBoundary from "./components/ErrorDefaultPage/ErrorBoundary";
// import ReactErrorPage from "./pages/ReactErrorPage";

// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import SIDdisclosures from "./components/SIDdisclosures/SIDdisclosures";

// import { ToastContainer } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';

// import Login from "./components/Login/Login";
// import CreateAccount from "./components/Login/CreateAccount/CreateAccount";

function App() {
  const location = useLocation();
  const hideLayout =
    location.pathname.startsWith("/products/aif") ||
    location.pathname.startsWith("/smscodeforscheme") ||
    location.pathname.startsWith("/JMWhatsAppAssistant");

  useEffect(() => {
    const tagManagerArgs = {
      gtmId: "GTM-NVJR53DB",
    };
    TagManager.initialize(tagManagerArgs);
  }, []);

  return (
    <div className="App">
      <CommonProvider>
        {/* <ErrorBoundary> */}
        {!hideLayout && <Header />}
        {/* <Header /> */}
        {/* <KycPopup /> */}

        {/* <NfoPopup/> */}
        <Routes>
          <Route path="/" element={<Home />} exact />
          <Route
            path="/RegistrationDetails"
            element={<RegistrationDetails />}
          />
          <Route
            path="/downloads/Statutory-Disclosure/Voluntary-Lock-in-Debit-freeze-facility-to-Mutual-Fund-Folio"
            element={<LockFreezePage />}
          />
          <Route
            path="/downloads/Statutory-Disclosure/Disclosure-of-Various-Payment-Options-along-with-their-efficiency-for-the-purpose-of-NAV-applicability"
            element={<PaymentEfficiency />}
          />
          <Route
            path="/downloads/Statutory-Disclosure/Unclaimed-Redemption-Dividend-Details"
            element={<MainUnclaimedHistory />}
          />
          <Route
            path="/Mutual-Fund-Conversion-Physical-to-Demat"
            element={<DematerialisationProcess />}
          />
          <Route path="/downloads/*" element={<DownloadNew />} />
          <Route path="/AboutUs" element={<AboutUs />} />
          <Route path="/AboutUs/*" element={<AboutUs />} />
          <Route path="/PopupButton" element={<PopupButton />} />
          <Route path="/Insights/*" element={<FinQ />} />
          <Route path="/View-Videos" element={<MeadiaVdieos />} />
          <Route path="/Grievance" element={<Grievance />} />
          <Route path="/FAQs" element={<FinQFAQ />} />
          <Route path="/Reach-Us" element={<ReachOut />} />
          <Route path="/Reach-Us/*" element={<ReachOut />} />
          <Route path="/PartnersCorner" element={<PartnersCorner />} />
          <Route path="/PartnersCorner/*" element={<PartnersCorner />} />
          <Route path="/CustomerServices" element={<CustomerServices />} />
          <Route path="/CustomerServices/*" element={<CustomerServices />} />
          <Route path="/Privacy-Policy" element={<PrivacyPolicy />} />
          <Route path="/Disclaimer" element={<Disclaimer />} />
          <Route path="/Terms-and-Conditions" element={<RulesAndRegulations />}/>
          <Route path="/Scheme-Expense-Ratio" element={<SchemeExpenseRatio />}/>
          <Route path="/Tabes" element={<TabsPartner />} />
          <Route path="/mutual-fund-products/:schemeType/:schemeName/:SchemeCode/:SchemeDesc" element={<Product />} />
          <Route path="/mutual-fund-products/*" element={<ProductSheme />} />
          <Route path="/NAVs-and-IDCW/*" element={<TabsNavDividend />} />
          <Route path="Communication-Hub/*" element={<CommunicationHub />} />
          <Route path="/products/:schemeType/:schemeName/:SchemeCode/:SchemeDesc" element={<Product />}/>
          <Route path="/products/" element={<ProductSheme />} />
          <Route path="/products/:category" element={<ProductSheme />} />
          <Route path="/Communication-Center" element={<MediaCenter />} />
          <Route path="/Communication-Center/*" element={<MediaCenter />} />
          <Route path="/Transmission-Units" element={<TransmissionUnits />} />
          <Route path="/ODRPortal" element={<ODRPortal />} />
          <Route path="/AboutUs/Sponsor" element={<Sponsor />} />
          <Route path="/AboutUs/Auditors" element={<Auditor />} />
          <Route path="/AboutUs/Custodian" element={<Custodian />} />
          <Route path="/AboutUs/Registrar" element={<Registar />} />
          <Route path="/smscodeforscheme" element={<SMSCodeForScheme />} />
          <Route path="/Company-Boilerplate" element={<CompanyBoilerplate />} />
          <Route path="Customer-Services/Contact-Us-Form"element={<ContactUsForm></ContactUsForm>}/>
          <Route path="/Unclaimed-Redemption-and-IDCW-(Dividend)" element={<MainUnclaimedHistory />} ></Route>
          <Route path="/AboutUs/Executive-Remuneration" element={<ExecutiveRemuneration />}/>
          <Route path="/TERRatio" element={<TERRatio />} />
          <Route path="/SIDdisclosures/*" element={<SIDdisclosures />} />
          <Route path="/aspnet_client" element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
          <Route path="/Thankyou-for-empanelment" element={<Draft1 />} />
          <Route path="/Thankyou" element={<Draft2 />} />
          {/* <Route path="/KycForm" element={<KycForm />} /> */}
          <Route path="/kycHTML" element={<kycHTML />} />
          <Route path="/Camsresponse" element={<Camsresponse />} />
          <Route path="/Insights/DocumentGallery/*" element={<DocumentGalleryInner />}/>
          <Route path="/Insights/Document-Gallery/" element={<DocumentGallery />}/>
          <Route path="/Insights/Calendar-2026" element={<Calendar2026 />} />
          <Route path="/Insights/Outlook-2026" element={<Outlook2026 />} />
          <Route path="/PaymentEfficacyMatrix" element={<PaymentEfficiency />}/>
          <Route path="/KycUpdate" element={<Kyc />} />
          <Route path="/Confirmation" element={<Confirmation />} />
          <Route path="/knowledgehubkyc" element={<FinQKYCOther />} />
          <Route path="/cyber-security-awareness" element={<CyberSecurity />} />
          {/* <Route path="/cobrandedPartners" element={<CobrandPartners/>}/> */}

          {/* <Route path="/PageDecryptAES" element={<PageDecryptAES />} /> */}
          {/* <Route path="/Downloads" element={<Download />} />     */}
          {/* <Route path="/sipcalculator" element={<SIPCalculator />} /> */}
          {/* <Route path="/sipcalculator" element={<SIPCalculator />} /> */}
          {/* <Route path="/downloads/*" element={<DownloadInner />} /> */}
          {/* <Route path="/Perspectives" element={<Perspective />} /> */}
          {/* <Route path="/HomePopup" element={<HomePopup />} /> */}

          {/* <Route path="/FinQ" element={<FinQ />} /> */}
          {/* <Route path="/FinQ/*" element={<FinQ />} /> */}
          {/* <Route path="/Insights/*" element={<FinQSectionNew />} /> */}
          {/* <Route path="Insights/Video-Gallery" element={<VideoGallery/>}/> */}
          {/* <Route path="/new-blog" element={<BlogPage/>}/> */}
          {/* <Route path="/new-blog/inner-blog-page/:id" element={<InnerBlogPage/>}/> */}

          {/* <Route
            path="/Blog-Details/:blogid/:BlogHeading"
            element={<BlogDetails />}
          /> */}
          {/* <Route path="/BranchLocator" element={<BranchLocator/>} />
            <Route path="/Corporate-Office" element={<KfinBranches/>} /> */}
          {/* <Route path="/iap" element={<IAPMicrosite/>}/> */}
          {/* <Route path="/Calculator/:tabName" element={<Calculator/>} /> */}
          {/* <Route path='/Nav' element={<TabsNavDividend/>}/> */}
          {/* <Route path='/NavsAndIDCW/*' element={<TabsNavDividend/>}/> */}
          {/* <Route path="/PartnersCorner" element={<LatestPartnerCorner/>}/>
          <Route path="/PartnersCorner/*" element={<LatestPartnerCorner/>}/> */}
          {/* <Route path="/Distributor-Empanelment-Details" element={<EmapanelledMfd/>}/> */}

          {/* <Route path="/Media-Center" element={<MediaCenter/>} />
            <Route path="/Media-Center/*" element={<MediaCenter/>} /> */}
          {/* {/* <Route path="/products/aif/aif-product/*" element={<AIFProductPage/>}/>  */}
          {/* <Route path="/products/aif/*" element={<AIFHomePage/>}/> 
          <Route path="/products/aif/about-us/*" element={<AIFAboutUs/>}/> 
          <Route path="/products/aif/:fundSlug" element={<AIFProductPage />} />
          <Route path="/products/aif/contact-us/" element={<AIFContactus/>}/> 
          <Route path="/products/aif/jm-financial/" element={<AIFInsights/>}></Route> */}
          {/* <Route path="/Communication-Center" element={<PressRelease/>} />
            <Route path="/Communication-Center/*" element={<PressRelease/>} /> */}
          {/* <Route path="/smscodeforscheme" element={<SmsCodeForSchemeNew />} /> */}
          {/* <Route path="/Factsheet-disclosures/*" element={<FactSheetDisclosures/>}/> */}
         
          <Route path="/JMWhatsAppAssistant"  element={<JMWhatsAppAssistant/>}/>
          {/* <Route path="/Login/OTPPopup" element={<OTPPopup/>}/> */}
          {/* <Route path="/Login" element={<Login/>}/> */}
          {/* <Route path="/Create-Account" element={<CreateAccount/>}/> */}

          {/* <Route path="/404" element={<NotFound />} /> */}

          {/* <Route path="/co-pms/*" element={<CoPms/>}/> */}
         
          {/* <Route path="/Careers" element={<Careers />} /> */}
         
          {/* <Route path="/Communication-Center/Videos" element={<MeadiaVdieos/>}/> */}
          {/* <Route path="/reactErrorPage" element={<ReactErrorPage />} /> */}
        </Routes>

        {/* <ToastContainer position="top-center" /> */}
        {!hideLayout && <Footer />}
        {/* <ScrollToTopButton />
        <AccessibilityWidget/> */}
        {/* <Footer /> */}
        {/* </ErrorBoundary> */}
      </CommonProvider>
    </div>
  );
}
export default App;
